<script setup>
import {computed, onUnmounted} from 'vue'
import {useRoute} from 'vue-router'
import {useOdpReportsStore} from '@/stores/odpReports'

const route = useRoute()
const odpReportsStore = useOdpReportsStore()

const formData = computed(() => odpReportsStore.formData)

const month = route.query.month || ''
formData.value.month = month

onUnmounted(() => {
    delete formData.value.month
})
</script>

<template>
    <select
        required
        v-model="formData.month"
        class="form-select form-select-sm"
        name="month"
        oninvalid="this.setCustomValidity('Please select a month')"
        oninput="this.setCustomValidity('')"
    >
        <option value="">Month&hellip;</option>
        <option
            v-for="(monthName, index) in ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']"
            :key="index"
            :value="index + 1"
        >
            {{ monthName }}
        </option>
    </select>
</template>